import axios from "@/utils/request"
export function phoneCode(data) {
  return axios({
    url: "/api/frontend/phoneCode",
    method: "POST",
    data
  })
}
export function register(data) {
  return axios({
    url: "/api/auth/register",
    method: "POST",
    data
  })
}
export function loginUser(data) {
  return axios({
    url: "/api/auth/login",
    method: "POST",
    data
  })
}
// 注册来源判断
export function setSession(params) {
  return axios({
    url: "/api/auth/setSession",
    method: "GET",
    params: params
  })
}
